import { render, staticRenderFns } from "./ClienteSemFaturamento2.vue?vue&type=template&id=737d906c&scoped=true&"
import script from "./ClienteSemFaturamento2.vue?vue&type=script&lang=js&"
export * from "./ClienteSemFaturamento2.vue?vue&type=script&lang=js&"
import style0 from "./ClienteSemFaturamento2.vue?vue&type=style&index=0&id=737d906c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737d906c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardActions,VCardTitle,VCol,VIcon,VRow,VTooltip})
